import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Article } from 'app/models/Article';
import { ImageComponent } from 'app/modules/image/image.component';
import { ConvertToSlugPipe } from 'app/shared/convert-to-slug.pipe';
import { ExtractTextFromHtmlPipe } from 'app/shared/extract-text-from-html.pipe';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-recommendation-article',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        ImageComponent,
        ExtractTextFromHtmlPipe,
        ConvertToSlugPipe,
    ],
    templateUrl: './recommendation-article.component.html',
})
export class RecommendationArticleComponent {
    @Input() listeMedias: Article[];
    @Input() type: 'ARTICLES' | 'NEWS';
    cloud_front = environment.cloud_front_host;
}
